import axios from 'services/api';
import { API2_HOST } from '../../helpers/urlHelper';
import { baseGetArraySaveToSession } from 'services/base-services/baseService';

axios.defaults.withCredentials = true;

// const baseURL = `https://eva.emplas.co.uk/Ajax/ODR/GetODRByStage.ashx`;
const baseURL = `${API2_HOST}/eva-odr-dashboard`;
const evaLink =
  process.env.REACT_APP_EVA_URL + '/Internal/ODR/ODRStageDashboard.aspx';
const odrUserCreatedByKey = 'odr-user-created-by';
const selectedOdrStages = 'selected-odr-stages';
const wdCustomerType = 'wd.customer.type';
const today = new Date();
const year = today.getFullYear();
const month = String(today.getMonth() + 1).padStart(2, '0'); 
const day = String(today.getDate()).padStart(2, '0');
const dateStr = `${year}${month}${day}`; 
const newAgeOdrLink = 
  process.env.REACT_APP_EVA_URL + `/dashboards/OdrAutomaticReport.aspx?date=${dateStr}`;

const getOdrUserCreatedBy = async () => {
  return baseGetArraySaveToSession(
    odrUserCreatedByKey,
    `${baseURL}/get-created-by-users`
  );
};

const getSelectedOdrStages = async () => {
  return baseGetArraySaveToSession(
    selectedOdrStages,
    `${baseURL}/get-selected-odr-stages`
  );
};
const getCustomerTypes = async () => {
  return baseGetArraySaveToSession(
    wdCustomerType,
    `${API2_HOST}/OptionList?optionKey=${wdCustomerType}&enable=true`
  );
};

async function getRequestBase() {
  const existed = sessionStorage.getItem('odrRequestBase');
  if (existed) {
    console.log('from store')
    return JSON.parse(existed);
  }
  console.log('from live')
  const requestBase = {
    stages: (await getSelectedOdrStages()).join(','),
    users: (await getOdrUserCreatedBy()).map(x => x.id.toString()).join(','),
    customerTypes: (await getCustomerTypes()).map(x => x.id).join(','),
    odrAge: '',
    odrAtRisk: 'atrisk',
    query: ''
  };

  sessionStorage.setItem('odrRequestBase', JSON.stringify(requestBase));

  return requestBase;
}

const getOneWeekODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-one-week-odrs`,
      data: { ...requestBase, odrAtRisk: '' },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(requestBase);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getOneWeekAtRiskODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-one-week-odrs`,
      data: { ...requestBase, odrAtRisk: 'atrisk' },
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(requestBase);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getOdrBase = async (url, anchor = '') => {
  try {
    const response = await axios({
      method: 'get',
      url: `${baseURL}/${url}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(response.data.data.paramObj);
      return {
        data: response.data.data.items,
        url: `${evaLink}?${params.toString()}`,
        urlInMail: `${newAgeOdrLink}${anchor}`
      };
    }

    return 0;
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getAtRiskODRs = async () => {
  // return getOdrBase('get-at-risk-odrs');
  try {
    const response = await axios({
      method: 'get',
      url: `${baseURL}/get-at-risk-odrs`,
      // data: requestBase,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    console.log(response);
    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(response.data.data.paramObj);
      return {
        data: response.data.data.items,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};
const getFaultSourceODRs = async () => {
  const exCludes = [
    'Commercial Contractor – Charge back ',
    'Commercial Supply Only'
  ];
  try {
    const requestBase = await getRequestBase();
    const response = await axios({
      method: 'get',
      url: `${API2_HOST}/OptionList?optionKey=wd.odr.fault.source&enable=true`,
      data: requestBase,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    return response.data?.filter(x => !exCludes.includes(x.name));
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getSupplierDeliveryChanges = async () => {
  return getOdrBase('get-supplier-delivery-changes');
};

const getSupplierDeliveryChangesAgedODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const request = {
      ...requestBase,
      stages: '6237',
      odrAtRisk: '',
      odrAge: 'old'
    };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getAgedODRs = async () => {
  return getOdrBase('get-aged-odrs', '#aged_odrs');
};

const getNncODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const request = { ...requestBase, odrAge: '', odrAtRisk: '' };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-nc-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getAgedAtRiskODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const request = { ...requestBase, odrAge: 'old', odrAtRisk: 'atrisk' };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getNewODRs = async () => {
  // return getOdrBase('get-new-odrs');
  try {
    const requestBase = await getRequestBase();
    const request = {
      ...requestBase,
      stages: requestBase.stages + ',2055',
      odrAge: 'new',
      odrAtRisk: ''
    };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`,
        urlInMail: `${newAgeOdrLink}#new_odrs`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getSupplierDeliveryChangesNewODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const request = {
      ...requestBase,
      stages: '6237',
      odrAtRisk: '',
      odrAge: 'new'
    };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

const getNewAtRiskODRs = async () => {
  try {
    const requestBase = await getRequestBase();
    const request = { ...requestBase, odrAge: 'new', odrAtRisk: 'atrisk' };
    const response = await axios({
      method: 'post',
      url: `${baseURL}/get-odrs`,
      data: request,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (
      response &&
      response.data.success &&
      response.data.data !== null &&
      response.data.data !== undefined
    ) {
      const params = new URLSearchParams(request);
      return {
        data: response.data.data,
        url: `${evaLink}?${params.toString()}`
      };
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return 0;
  }
};

export {
  getRequestBase,
  getAtRiskODRs,
  getSupplierDeliveryChanges,
  getSupplierDeliveryChangesAgedODRs,
  getSupplierDeliveryChangesNewODRs,
  getAgedODRs,
  getNewODRs,
  getFaultSourceODRs,
  getAgedAtRiskODRs,
  getNewAtRiskODRs,
  getOneWeekODRs,
  getOneWeekAtRiskODRs,
  getNncODRs
};
